define([
	"dojo/_base/declare",
	"csi",
	"csi/html",
	"Sourcing/NewMaterialSupplierRequest"
], function(declare,csi,html,NewMaterialSupplierRequest) {

	return declare(NewMaterialSupplierRequest, {
		constructor: function(/*Object*/params) {
			// summary: parent should point to MaterialPlanPlacement(Colorway)
			this.m_urlParent = html.getElementContext(this.refNode);
			this.m_idAttrParent = this.heading.m_id;

			// set product to empty to skip product pages - this action is for requesting new material samples rather than
			// samples for existing materials
			this._urlProduct = csi.EMPTY_URL;
		}
	});
});